import { api } from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout() {
  try {
    const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
      return true;
    }
    toast.error("Could not start checkout");
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Could not start checkout");
  }
  return false;
}

export async function openBillingPortal() {
  try {
    const { data } = await api.post("/payments/portal", { origin_url: window.location.origin });
    if (data.portal_url) {
      window.location.href = data.portal_url;
      return true;
    }
    toast.error("Could not open billing portal");
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Could not open billing portal");
  }
  return false;
}
